import { observer } from 'mobx-react';
import React from 'react';
import { CaretDownOutlined, CaretRightOutlined } from '@ant-design/icons';

import { GridDataEntry } from 'controls/grid/gridDataEntry';
import { GridColumnConfig } from 'controls/grid/gridColumnConfig';
import { GridStore } from 'controls/grid/gridStore';
import { GridDataItem } from 'controls/grid/gridDataItem';
import { AntButton } from 'controls/react/ant/antButton';

export const ROW_EXPANSION_COLUMN_FIELD_NAME = '__rowExpansion';

type RowExpanderButtonProps<DataItem extends GridDataEntry> = {
	store: GridStore<DataItem>;
	item: GridDataItem<DataItem>;
	rowIndex: number;
};

const RowExpanderButton = observer(<DataItem extends GridDataEntry>(props: RowExpanderButtonProps<DataItem>) => {
	const { store, item, rowIndex } = props;
	const expanded = store.isRowExpanded(item.id);

	const onClick = (e: React.MouseEvent) => {
		e.stopPropagation();
		store.toggleRowExpansion(item.id, rowIndex);
	};

	return (
		<AntButton
			type={'text'}
			size={'small'}
			icon={expanded ? <CaretDownOutlined /> : <CaretRightOutlined />}
			onClick={onClick}
		/>
	);
});

export function getExpanderColumn<DataItem extends GridDataEntry>(
	store: GridStore<DataItem>,
): GridColumnConfig<DataItem> {
	return {
		field: ROW_EXPANSION_COLUMN_FIELD_NAME,
		title: '',
		sortable: false,
		fixed: 'left',
		expandOnClick: false,
		rendererHeader: () => null,
		renderer: (item, extra) => ({
			content: <RowExpanderButton item={extra.gridItem} store={store} rowIndex={extra.rowIndex} />,
			centerContent: true,
		}),
		width: 32,
	};
}
